// extracted by mini-css-extract-plugin
module.exports = {"container":"RichText_container__LmSLN","richText":"RichText_richText__1mraZ","ql-direction-rtl":"RichText_ql-direction-rtl__3txxh","error":"RichText_error__2A0IK"};